import http from '@/utils/Http'
import {ProductCategory, Product} from "@/model";

const searchState = () => {
    return {
        current_page: 1,
        per_page: 0,
        total_entries: 0,
        entries: []
    }
};

const BASE_PATH = '/v1/products';

const loadEntries = (path) => {
    return new Promise((resolve, reject) => {
        http.get(path)
            .then(({data}) => resolve(data))
            .catch(reject);
    })
};

export default {
    namespaced: true,
    state: {
        search: searchState(),
        categories: [],
        all: [],
    },
    getters: {
        search(state) {
            return state.search;
        },
        categories(state) {
            return state.categories;
        },
        all: state => state.all,
    },
    mutations: {
        resetSearch(state, defaultValues = {}) {
            state.search = Object.assign({}, searchState(), defaultValues);
        },
        setSearch(state, payload) {
            state.search = payload;
        },
        setCategories(state, payload) {
            state.categories = payload
        },
        setProducts(state, items) {
            state.all = items
        }
    },
    actions: {
        async filter({commit, state}, path) {
            return new Promise((resolve, reject) => {
                loadEntries(path)
                    .then(data => {
                        commit('setSearch', Object.assign({}, state.search, data));
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async loadMore({}, path) {
            return loadEntries(path);
        },
        async resetSearch({commit}, defaultValues = {}) {
            commit('resetSearch', defaultValues);
        },
        async destroy({commit}, id) {
            return new Promise((resolve, reject) => {
                http.delete(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async load({commit}, id) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async save({commit}, payload) {
            return new Promise((resolve, reject) => {
                if(payload.id) {
                    http.put(`${BASE_PATH}/${payload.id}`, {product: payload})
                        .then(({data}) => resolve(data))

                        .catch(err => reject(err));
                } else {
                    http.post(BASE_PATH, {product: payload})
                        .then(({data}) => resolve(data))
                        .catch(err => reject(err));
                }
            })
        },
        async loadCategories({commit}) {
            return new Promise((resolve, reject) => {

                ProductCategory.all()
                    .then(data => {
                        commit('setCategories', data);
                        resolve(data);
                    })
                    .catch(console.error);

                http.get(`${BASE_PATH}/load_categories`)
                    .then(({data}) => {
                        commit('setCategories', data);
                        ProductCategory.putAll(data);
                        resolve(data);
                    })
                    .catch(err => {
                        console.error(err);
                        reject(err);
                    });
            })
        },
        async loadAll({commit}) {
            return new Promise((resolve, reject) => {

                let exists = false;

                Product.all()
                    .then(data => {
                        commit('setProducts', data);
                        resolve(data);
                        exists = true;
                    })
                    .catch(console.error);

                http.get(`${BASE_PATH}/load_all`)
                    .then(({data}) => {
                        commit('setProducts', data);
                        Product.putAll(data);
                        if (!exists) resolve(data);
                    })
                    .catch(err => {
                        console.error(err);
                        reject(err);
                    });
            })
        }
    }
}
